var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovieManifestationBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1875 6C5.08293 6 4.1875 6.89543 4.1875 8V40C4.1875 41.1046 5.08293 42 6.1875 42H42.1875C43.2921 42 44.1875 41.1046 44.1875 40V8C44.1875 6.89543 43.2921 6 42.1875 6H6.1875ZM10.1875 8H6.1875V10H10.1875V8ZM12.5875 8H16.5875V10H12.5875V8ZM22.9875 8H18.9875V10H22.9875V8ZM25.3875 8H29.3875V10H25.3875V8ZM35.7875 8H31.7875V10H35.7875V8ZM38.1875 8H42.1875V10H38.1875V8ZM10.1875 40H6.1875V38H10.1875V40ZM12.5875 40H16.5875V38H12.5875V40ZM22.9875 40H18.9875V38H22.9875V40ZM25.3875 40H29.3875V38H25.3875V40ZM35.7875 40H31.7875V38H35.7875V40ZM38.1875 40H42.1875V38H38.1875V40ZM17.1875 17.618C17.1875 16.8747 17.9698 16.3912 18.6347 16.7236L31.3986 23.1056C32.1357 23.4741 32.1357 24.5259 31.3986 24.8944L18.6347 31.2764C17.9698 31.6088 17.1875 31.1253 17.1875 30.382V17.618Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieManifestationBlack);
export default __webpack_public_path__ + "static/media/movie_manifestation_black.9ab5d23800427bbda7b00f1d52ea2d4c.svg";
export { ForwardRef as ReactComponent };